import { render, staticRenderFns } from "./UploadViewer.vue?vue&type=template&id=6601ec5f&scoped=true&"
import script from "./UploadViewer.vue?vue&type=script&lang=ts&"
export * from "./UploadViewer.vue?vue&type=script&lang=ts&"
import style0 from "./UploadViewer.vue?vue&type=style&index=0&id=6601ec5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6601ec5f",
  null
  
)

export default component.exports